import { render } from "./EtShow.vue?vue&type=template&id=ae2f5f6e"
import script from "./EtShow.vue?vue&type=script&lang=js"
export * from "./EtShow.vue?vue&type=script&lang=js"

import "./EtShow.vue?vue&type=style&index=0&id=ae2f5f6e&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__